var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLevel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "Level_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 7,
  width: 32,
  height: 32
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 23.567H2.133v12.8H11.2m0 0v-19.2h9.6m-9.6 19.2h9.6m0 0h9.067V8.633H20.8v27.734Z",
  stroke: "#fff",
  strokeWidth: 2.133,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Level_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.407 5.907h-32v32h32v-32Z",
  fill: "#504C53"
}))));
export default SvgLevel;